import { ComponentProps } from 'react';
import { Avatar } from '@getsynapse/design-system';
import { ProjectOwner } from 'types/store/projectsList';
import { ProjectStatus } from 'utils/types/projectsList';
import { INACTIVE_PROJECTS_STATUSES } from 'utils/constants/projectsList';
import { isUserStatusDisabled } from 'utils/functions';

type AvatarProps = ComponentProps<typeof Avatar>;

export const mapProjectOwnerToAvatar: (
  owner: ProjectOwner,
  multiple?: boolean
) => AvatarProps = (owner, multiple = false) => {
  if (!owner.name || owner.name.length === 0) {
    return {
      imageSrc: '',
      initial: '',
      name: '',
      disabled: false,
      size: 'medium',
    };
  }
  const allInitials = owner.name.split(' ').map((name) => name[0]);
  let initial = allInitials[0].charAt(0);
  if (!multiple && allInitials.length > 1) {
    initial += allInitials[1].charAt(0);
  }
  return {
    imageSrc: owner.avatarUrl || '',
    initial,
    name: owner.name,
    disabled: isUserStatusDisabled(owner.status),
    size: 'medium' as AvatarProps['size'],
  };
};

export const isProjectCompletionDatePast: (
  status: ProjectStatus,
  targetCompletionDate: string | undefined
) => boolean = (status, targetCompletionDate) => {
  if (!targetCompletionDate) {
    return false;
  }

  if (
    INACTIVE_PROJECTS_STATUSES.includes(
      status as 'completed' | 'canceled' | 'closed'
    )
  ) {
    return false;
  }

  const targetDate = new Date(targetCompletionDate);
  const currentDate = new Date();
  currentDate.setHours(0, 0, 0, 0);
  return targetDate.getTime() < currentDate.getTime();
};
